module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Ladder-279e3628a5957741a5b8799ad7dd3958.svg";